var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: _vm.id_anexo } }, [
    _c(
      "div",
      [
        _c(
          "transition-group",
          { attrs: { name: "slide-fade" } },
          _vm._l(_vm.anexos, function (anexo, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.display_images ||
                      (_vm.display_images &&
                        !_vm.filterExtensionImg(anexo.formato)),
                    expression:
                      "!display_images || (display_images && !filterExtensionImg(anexo.formato))",
                  },
                ],
                key: anexo.id_anexo,
                staticClass: "dropdown py-1 text-left p-0",
              },
              [
                _c(
                  "a",
                  {
                    key: anexo.id_anexo + "-" + index,
                    staticClass:
                      "cursor-pointer text-hover-primary text-hover-underline dropdown",
                    attrs: {
                      id: "anexo-" + anexo.id_anexo,
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "mr-2",
                      domProps: {
                        innerHTML: _vm._s(_vm.iconeAnexo(anexo.formato)),
                      },
                    }),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(anexo.name_file) },
                    }),
                    _vm._v(" "),
                    anexo.doc !== "doc"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "ml-2 badge badge-light badge-pill font-weight-normal",
                            attrs: { title: "Classificação do documento" },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(anexo.doc) +
                                "\n                        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    anexo.config
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "ml-2 badge badge-secondary badge-pill font-weight-normal",
                            attrs: { title: "Registrado no PNCP" },
                          },
                          [
                            _vm._v(
                              "\n                            pncp\n                        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    anexo.n_assinaturas > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "ml-2",
                            attrs: {
                              title: "Documento assinado eletrônicamente",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-file-signature text-primary",
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.marks
                      ? _c("span", {
                          staticClass: "ml-2",
                          domProps: { innerHTML: _vm._s(_vm.getMarks(anexo)) },
                        })
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.data_request_download || _vm.request_delete || _vm.edit
                  ? _c(
                      "div",
                      {
                        staticClass: "dropdown-menu shadow rounded",
                        attrs: { "aria-labelledby": "anexo-" + anexo.id_anexo },
                      },
                      [
                        anexo.assinar || anexo.n_assinaturas > 0
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item text-hover-primary cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.assinar(anexo.id_anexo)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-file-signature text-inherit",
                                }),
                                _vm._v(" Assinatura"),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.data_request_download
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item text-hover-primary cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadFile(anexo)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-download text-inherit",
                                }),
                                _vm._v(" Baixar"),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.edit
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item text-hover-primary cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.editar(anexo)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-edit text-inherit",
                                }),
                                _vm._v(" Editar"),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("options", null, null, {
                          index: index,
                          data: anexo,
                        }),
                        _vm._v(" "),
                        _vm.request_delete
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item text-hover-danger cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteFile(anexo)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "far fa-trash-alt text-inherit",
                                }),
                                _vm._v(" Excluir"),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        !_vm.carregando && _vm.anexos.length === 0
          ? _c("div", { staticClass: "alert alert-warning mb-0" }, [
              _vm._v(
                "\n                Nenhum arquivo encontrado!\n            "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.carregando
          ? _c(
              "div",
              {
                staticClass:
                  "p-2 text-center col-12 d-flex align-items-center justify-content-center",
              },
              [
                _c("hollow-dots-spinner", {
                  attrs: {
                    "animation-duration": 1000,
                    "dot-size": 10,
                    "dots-num": 3,
                    color: "#6F787D",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }